import { AutoCompleteDesignTokens } from '@primeuix/themes/types/autocomplete';

export const AUTOCOMPLETE_STYLES: AutoCompleteDesignTokens = {
  css: () => `
    .p-autocomplete-overlay {
      max-width: 24rem;
    }

    .p-autocomplete-overlay .p-autocomplete-option,
    .p-autocomplete-overlay .p-autocomplete-empty-message {
      font-size: 0.8125rem;
    }

    .p-autocomplete-list-container {
      overflow-y: auto;
    }`,
};
